import React, { useState } from 'react'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'
import ReactJoyride, { CallBackProps, STATUS } from 'react-joyride'

import Tooltip from 'components/Tooltip'
import { ReactComponent as ArrowIcon } from 'static/svg/onboarding-arrow-icon.svg'
import { AUTO_FILLING_GUIDE_MEDICAL_RECORD_ONBOARDING } from 'settings/_storageFlagsSettings'

import { useOctadeskChat } from 'hooks'
import disableScroll from 'utils/disableScroll'

import * as S from './styles'

type OnBoardingStatus = typeof STATUS[keyof typeof STATUS]

interface TooltipWrapperProps {
  children: React.ReactNode
}

interface AutoFillGuideMedicalRecordOnboardingProps {
  onFinish?: () => void
}

const text = (
  <Typography inheritColor variant="content2" weight='bold' inlineStyles={{ lineHeight: '22px' }}>
    Acesse as dúvidas para <br /> entender como funciona o <br /> preenchimento automático <br /> do prontuário.
  </Typography>
)

const TooltipWrapper = ({ children }: TooltipWrapperProps) => (
  <S.TooltipWrapper>
    <ArrowIcon />
    {children}
  </S.TooltipWrapper>
)

export const AutoFillGuideMedicalRecordOnboarding = ({
  onFinish
}: AutoFillGuideMedicalRecordOnboardingProps): JSX.Element => {
  const { isMobile } = useDimensions()
  const [onBoardingStatus, setOnBoardingStatus] = useState<OnBoardingStatus>(STATUS.IDLE)
  const onboardingStatusOnLocalStorage = localStorage.getItem(AUTO_FILLING_GUIDE_MEDICAL_RECORD_ONBOARDING)
  useOctadeskChat({ hide: onBoardingStatus === STATUS.RUNNING })

  const handleJoyrideCallback = (data: CallBackProps) => {
    if (data.status === STATUS.RUNNING) {
      setOnBoardingStatus(STATUS.RUNNING)
      return disableScroll.on()
    }

    if (data.status === STATUS.FINISHED) {
      setOnBoardingStatus(STATUS.FINISHED)
      localStorage.setItem(AUTO_FILLING_GUIDE_MEDICAL_RECORD_ONBOARDING, JSON.stringify(STATUS.FINISHED))
      disableScroll.off()
      onFinish?.()
    }
  }

  return (
    <ReactJoyride
      run={!isMobile && onboardingStatusOnLocalStorage !== JSON.stringify(STATUS.FINISHED)}
      callback={handleJoyrideCallback}
      tooltipComponent={(props) => (
        <TooltipWrapper>
          <Tooltip {...props} />
        </TooltipWrapper>
      )}
      steps={[
        {
          content: text,
          target: '#modal-generic-header-action-element',
          placement: 'bottom',
          offset: 25,
          disableBeacon: true,
          floaterProps: {
            disableAnimation: true,
            disableFlip: true,
            hideArrow: true,
            offset: 25,
          },
        },
      ]}
      disableOverlayClose
      disableScrolling
      spotlightPadding={2}
      floaterProps={{
        disableAnimation: true,
        disableFlip: true,
        hideArrow: true,
        styles: {
          floater: {
            zIndex: 99999999999999,
            filter: 'none',
          },
        },
      }}
      styles={{
        options: {
          arrowColor: 'transparent',
          overlayColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 99999999999999,
        },
        overlay: {
          zIndex: 99999999999998,
        },
        spotlight: {
          borderRadius: '100%',
        }
      }}
    />
  )
}